export default __webpack_public_path__ + "static/media/Header04.6ebf5510.jpg";